import { render, staticRenderFns } from "./AccountConfigList.vue?vue&type=template&id=13f417a9&"
import script from "./AccountConfigList.vue?vue&type=script&lang=ts&"
export * from "./AccountConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports